import { useTranslation } from "react-i18next";
import { useLoaderData, useRouteLoaderData } from "react-router-dom";
import { useState } from "react";
import { useSearch } from "../../react-helpers/array";
import {
  CandidateInvitation,
  Organization,
} from "../../services/organization/organizationModel";
import InviteCandidatesDialog from "./InviteCandidatesDialog";
import InvitedCandidatesTable from "./InvitedCandidatesTable";

const OrganizationInvitedCandidatesPage = () => {
  const { t } = useTranslation(["organization"]);
  const { organization } = useRouteLoaderData("organization") as {
    organization: Organization;
  };
  const { candidateInvitations } = useLoaderData() as {
    candidateInvitations: CandidateInvitation[];
  };

  const [searchedInvitations, setSearch] = useSearch(
    candidateInvitations,
    (candidateInvitation) => ({ email: candidateInvitation.email }),
  );

  const [isInviteDialogOpen, setInviteDialogOpen] = useState(false);

  return (
    <div className="layout_content --bg--organization-dashboard">
      <div className="ui-page pro-screen">
        <div className="ui-ph">
          <div className="ui-ph_t">
            <h1>{t("organization:invited-candidates.PAGE_TITLE")}</h1>
            <p>{t("organization:invited-candidates.SUBTITLE")}</p>
          </div>
          <button className="btn" onClick={() => setInviteDialogOpen(true)}>
            <span className="pro-ico --plus" aria-hidden="true" />
            {t("organization:candidates-profiles.INVITE_BUTTON")}
          </button>
        </div>

        {/* Explication de l'invitation (prod) : gardée, son bouton est celui de l'en-tête. */}
        <div className="ui-banner --ok lblock--l">
          <div className="ui-banner_grow">
            <b>{t("organization:candidates-profiles.INVITE_CANDIDATES")}</b>
            {t("organization:candidates-profiles.INVITE_MAIL_MESSAGE")}
          </div>
        </div>

        <div className="pro-search">
          <span className="pro-ico --search" aria-hidden="true" />
          <input
            type="search"
            className="input"
            placeholder={t("organization:invited-candidates.SEARCH_EMAIL")}
            aria-label={t("organization:invited-candidates.SEARCH_EMAIL")}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <InvitedCandidatesTable candidateInvitations={searchedInvitations} />
      </div>

      {isInviteDialogOpen && (
        <InviteCandidatesDialog
          onClose={() => setInviteDialogOpen(false)}
          organization={organization}
        />
      )}
    </div>
  );
};

export default OrganizationInvitedCandidatesPage;
